
import {Component} from 'vue-property-decorator';
import TableFilterable from '@/components/reports-v3/components/filterables/TableFilterable.vue';
import FilterWidget from '@/components/reports-v3/components/codedWidgets/shared/FilterWidget.vue';
import {PermissionsGroup} from '@/store/models.def';
import Checkbox from 'primevue/checkbox';
import moment from 'moment';
import { getTableName } from '@/worker/db/sqlHelpers';
import {TableItemFormatter} from '@/components/reports-v3/components/elements/charts/helpers/tableItemFormatter';

@Component({
    components: {
        TableFilterable,
        Checkbox,
    },
})
export default class NonStopAutoDashboard extends FilterWidget {

    public get permissionIds(): PermissionsGroup[] {
        return ['stocks'];
    }

    public get exportFileName() {
        const formattedDate = moment(this.selectedAsOfDate).format('DD MMM YY');
        return 'Maintain Stock Item' + '_' + 'As Of ' + formattedDate;
    }

    public get dateFormatted() {
        return [this.selectedAsOfDate];
    }

    public get expensiveHook() {
        const { selectedAsOfDate } = this;
        return JSON.stringify([
            selectedAsOfDate,
        ]);
    }

    public get date() {
        return this.selectedAsOfDate;
    }

    public get newTableFields(): any [] {
        const table = [
            {
                key: 'barcode',
                sortable: true,
                stickyColumn: true,
            },
            {
                key: 'item_desc',
                sortable: true,
                stickyColumn: true,
            },
            {
                key: 'item_code',
                sortable: true,
                stickyColumn: true,
            },
            {
                key: 'bal_qty',
                sortable: true,
                stickyColumn: true,
            },
            {
                key: 'uom',
                sortable: true,
                stickyColumn: true,
            },
            {
                key: 'ref_cost',
                sortable: true,
                stickyColumn: true,
                formatter: TableItemFormatter.currencySplit,
            },
            {
                key: 'ref_price',
                sortable: true,
                stickyColumn: true,
                formatter: TableItemFormatter.currencySplit,
            },
            {
                key: 'remark',
                sortable: true,
                stickyColumn: true,
            },
        ];
        return table;
    }

    public filterIds: Array<
        | 'dateAsOf'
    > = ['dateAsOf'];

    public afterCalculationTableItems: any [] = [];

    public async expensiveCalc() {
        const table = getTableName('diyMaintainStockItem');

        const jobId = this.currentJobId;
        const queryHead = await this._ensureTablesLoaded(
            ['diyMaintainStockItem'],
        );
        this.checkInterrupted(jobId);

        this.generateLoadingText(0.3);

        const rows = await queryHead.rawQuery(`
            SELECT "BARCODE" as barCode,
                "DESCRIPTION" as itemDesc,
                "CODE" as itemCode,
                TRY_CAST("BALSQTY" AS DOUBLE) as balQty,
                "UOM" as uom,
                TRY_CAST("REFCOST" AS DOUBLE) as refCost,
                TRY_CAST("REFPRICE" AS DOUBLE) as refPrice,
                "REMARK1" as remark1
            FROM ${table}
        `);
        this.checkInterrupted(jobId);

        // Group by itemCode, take last entry per group (matches original nestedGroupBy logic)
        const byCode: Record<string, any> = {};
        for (const row of rows) {
            byCode[row.itemCode] = row;
        }

        this.afterCalculationTableItems = Object.keys(byCode).map((code) => {
            const r = byCode[code];
            return {
                barcode: r.barCode,
                item_desc: r.itemDesc,
                item_code: r.itemCode,
                bal_qty: Number(r.balQty) || 0,
                uom: r.uom,
                ref_cost: Number(r.refCost) || 0,
                ref_price: Number(r.refPrice) || 0,
                remark: r.remark1,
            };
        });

        this.generateLoadingText(1);

        this.saveHistory('afterCalculationTableItems');
    }
}
